module.exports = __webpack_public_path__ + "SP_SPS9-ArtSupplies-8b324b752950a20a8bb7fdfe71ab048a.png";